import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Gift, Sparkles, ChevronRight } from 'lucide-react';
import { useAuth } from '../App';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * 🎁 Élodie #1095 — Bandeau Pack Bienvenue en pleine largeur au dessus du "Bonjour"
 * sur la page d'accueil. Affiche le compte à rebours et renvoie sur la page dédiée.
 */
const StarterPackHomeBanner = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      if (!token) return;
      try {
        const r = await axios.get(`${BACKEND_URL}/api/starter-pack/status`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setStatus(r.data);
      } catch { /* silent */ }
    };
    fetch();
    const iv = setInterval(fetch, 60000);
    return () => clearInterval(iv);
  }, [token]);

  if (!status || !status.is_active || !status.days_left || status.days_left <= 0) {
    return null;
  }

  const daysLeft = status.days_left;
  const hoursLeft = status.hours_left;
  const label =
    daysLeft > 1
      ? `${daysLeft} jours`
      : hoursLeft && hoursLeft > 0
      ? `${hoursLeft}h`
      : '1 jour';

  return (
    <button
      onClick={() => navigate('/dashboard/starter-pack')}
      className="w-full mb-4 rounded-2xl bg-gradient-to-r from-[#E8A5C4] via-[#EEB8CE] to-[#D48CB0] shadow-lg text-white p-3 flex items-center gap-3 hover:shadow-xl transition-all group animate-in fade-in slide-in-from-top-2"
      data-testid="starter-pack-home-banner"
      aria-label={`Pack Bienvenue MamaLink actif, il reste ${label}`}
    >
      <div className="relative flex-shrink-0">
        <div className="w-11 h-11 rounded-2xl bg-white/25 backdrop-blur flex items-center justify-center">
          <Gift className="w-5 h-5 text-white" strokeWidth={2.5} />
        </div>
        <Sparkles className="absolute -top-1 -right-1 w-4 h-4 text-yellow-200 animate-pulse" strokeWidth={2.5} />
      </div>
      <div className="flex-1 text-left">
        <p className="text-[10px] font-black uppercase tracking-widest text-white/90">
          🎁 Pack Bienvenue MamaLink
        </p>
        <p className="text-sm font-bold leading-tight">
          Il te reste <span className="font-black underline underline-offset-2">{label}</span> pour en profiter
        </p>
      </div>
      <ChevronRight className="w-5 h-5 text-white/90 group-hover:translate-x-0.5 transition-transform" />
    </button>
  );
};

export default StarterPackHomeBanner;
